import type { MouseEvent } from 'react';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Hero } from './components/sections/Hero';
import { ValueProps } from './components/sections/ValueProps';
import { HowItWorks } from './components/sections/HowItWorks';
import { Features } from './components/sections/Features';
import { FinalCta } from './components/sections/FinalCta';
import { PendingNoticeProvider } from './components/ui/ComingSoon';

export default function App() {
  /**
   * Lleva el foco al contenido, además del scroll que ya hace el ancla.
   *
   * Se hace en JS y no sólo con el href porque los navegadores no enfocan el
   * destino de un fragmento cuando no es un elemento interactivo: mueven el
   * "punto de partida de la navegación secuencial", que Safari en particular
   * ignora. Sin esto el salto es invisible para quien navega con teclado.
   */
  const handleSkip = (event: MouseEvent<HTMLAnchorElement>) => {
    const main = document.getElementById('contenido');
    if (!main) return; // el href se encarga; nada que arreglar
    event.preventDefault();
    main.focus();
    main.scrollIntoView({ block: 'start' });
  };

  return (
    <PendingNoticeProvider>
      {/*
       * Salto directo al contenido: un usuario de teclado no debería tener que
       * tabular la navegación entera en cada carga. Sólo aparece al enfocarlo.
       *
       * `position: fixed` y no `absolute`: en absolute el enlace se pinta en el
       * flujo, encima del logotipo de la navbar, y si el foco llega con la
       * página ya desplazada aparece fuera de la pantalla. Fijo y por debajo de
       * los 78px de la navbar no tapa nada y siempre queda visible.
       */}
      <a
        href="#contenido"
        onClick={handleSkip}
        className="sr-only focus:not-sr-only focus:fixed focus:top-[90px] focus:left-7 focus:z-100 focus:rounded-btn focus:bg-brand focus:px-5 focus:py-3 focus:font-display focus:text-sm focus:font-semibold focus:text-white focus:shadow-btn"
      >
        Saltar al contenido
      </a>

      <Navbar />

      {/*
       * tabIndex={-1} es lo que hace que el enlace de arriba haga algo.
       *
       * Un salto a #contenido sólo mueve el scroll; el foco se queda en el
       * enlace, así que el siguiente Tab vuelve a la navbar y para el usuario
       * el botón "no hace nada". Con el <main> enfocable programáticamente,
       * handleSkip le pasa el foco y la tabulación continúa desde el contenido.
       */}
      <main id="contenido" tabIndex={-1} className="outline-none">
        <Hero />
        <ValueProps />
        <HowItWorks />
        <Features />
        <FinalCta />
      </main>

      <Footer />
    </PendingNoticeProvider>
  );
}
